<template>
  <Teleport to="body">
    <div v-if="show" class="bravo fixed inset-x-0 bottom-24 z-50 flex justify-center pointer-events-none" role="status">
      <div class="relative">
        <span
          v-for="n in notes"
          :key="n.id"
          class="note absolute text-indigo-400 dark:text-indigo-300"
          :style="{ left: `${n.x}px`, fontSize: `${n.size}px`, animationDelay: `${n.delay}ms`, '--drift': `${n.drift}px` }"
        >{{ n.glyph }}</span>
        <div class="pill px-4 py-2 rounded-full shadow-lg bg-surface dark:bg-surface-muted-dark border border-stroke dark:border-stroke-dark">
          <span class="font-semibold text-fg-base dark:text-fg-base-dark">Bravo!</span>
          <span class="text-sm text-fg-muted dark:text-fg-muted-dark ml-1.5">All attendance is in.</span>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script setup>
import { ref } from 'vue'

const GLYPHS = ['♪', '♫', '♩', '♬']
const show = ref(false)
const notes = ref([])
let timer = null

const play = () => {
  notes.value = Array.from({ length: 7 }, (_, i) => ({
    id: `${Date.now()}-${i}`,
    glyph: GLYPHS[i % GLYPHS.length],
    x: 10 + i * 30 + Math.random() * 12,
    size: 16 + Math.random() * 10,
    delay: Math.random() * 300,
    drift: Math.random() * 24 - 12,
  }))
  show.value = true
  clearTimeout(timer)
  timer = setTimeout(() => { show.value = false }, 1500)
}

defineExpose({ play })
</script>

<style scoped>
.pill {
  animation: pop 1.5s cubic-bezier(.3, 1.5, .5, 1) forwards;
}
.note {
  top: 0;
  opacity: 0;
  animation: float-up 1.3s ease-out forwards;
}
@keyframes pop {
  0%   { opacity: 0; transform: translateY(8px) scale(.85); }
  15%  { opacity: 1; transform: translateY(0) scale(1); }
  80%  { opacity: 1; transform: translateY(0) scale(1); }
  100% { opacity: 0; transform: translateY(-4px) scale(.98); }
}
@keyframes float-up {
  0%   { opacity: 0; transform: translate(0, 0) rotate(0); }
  20%  { opacity: 1; }
  100% { opacity: 0; transform: translate(var(--drift), -70px) rotate(12deg); }
}
@media (prefers-reduced-motion: reduce) {
  .note { display: none; }
  .pill { animation: fade 1.5s linear forwards; }
  @keyframes fade { 0%, 85% { opacity: 1; } 100% { opacity: 0; } }
}
</style>
